<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a searchable list drop down intended for use in searches
    *
    * @since 20220823
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2022 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <div>
        <div v-if="searchableList !== undefined && searchableList !== null && canUpdate && !readOnly" :class="formGroupClass !== undefined && formGroupClass !== null ? formGroupClass : ['form-group']" style="min-width:150px">
            <label v-if="!hide_label" :class="formLabelClass !== undefined && formLabelClass !== null ? formLabelClass : []">{{searchableList.name}}</label>
            <div :class="formControlClass !== undefined && formControlClass !== null ? formControlClass : ['input-group']"> 
                <div v-if="autoSave" class="input-group-prepend">
                    <span v-if="errorOccured" class="input-group-text text-danger" id="basic-addon1"><i class="fa fa-times"></i></span>
                    <span v-else-if="saving" class="input-group-text" id="basic-addon1"><i class="fas fa-sync fa-spin"></i></span>
                    <span v-else class="input-group-text text-success" id="basic-addon1"><i class="fa fa-check"></i></span>
                </div>
                <input v-if="searchableList.element_type == 1" type="text" class="form-control" :name="name" :value="listData" :key="searchableList.id + '_' + dataItem.id" :placeholder="placeHolder" @change="saveList" v-on:input="updateList($event)" />
                <template v-else-if="searchableList.element_type == 2">
                    <div v-if="default_select.length == 0 && (!searchableList.hasDefault || forceDefault)" :class="['custom-control-inline', 'custom-control custom-radio']">
                        <input v-if="!readOnly" type="radio" class="custom-control-input" :name="name" :id="'search_list_' + searchableList.id + '_' + default_select_value" :value="default_select_value" @change="saveList" v-model="listData" v-on:input="updateList($event)">
                        <input v-else disabled type="radio" class="custom-control-input" :name="name" :id="'search_list_' + searchableList.id + '_' + default_select_value" :value="default_select_value" v-model="listData">
                        <label class="custom-control-label" :for="'search_list_' + searchableList.id + '_' + default_select_value"><span v-html="'Please select a '+ searchableList.name"></span></label>
                    </div>
                    <div v-else-if="!searchableList.hasDefault || forceDefault" :value="default_select_value" :class="['custom-control-inline', 'custom-control custom-radio']">
                        <input v-if="!readOnly" type="radio" class="custom-control-input" :name="name" :id="'search_list_' + searchableList.id + '_' + default_select_value" :value="default_select_value" @change="saveList" v-model="listData" v-on:input="updateList($event)">
                        <input v-else disabled type="radio" class="custom-control-input" :name="name" :id="'search_list_' + searchableList.id + '_' + default_select_value" :value="default_select_value" v-model="listData">
                        <label class="custom-control-label" :for="'search_list_' + searchableList.id + '_' + default_select_value"><span v-html="default_select"></span></label>
                    </div>
                    <div v-if="!searchableList.hasDefault && showUnset" :value="0" :class="['custom-control-inline', 'custom-control custom-radio']">
                        <input v-if="!readOnly" type="radio" class="custom-control-input" :name="name" :id="'search_list_' + searchableList.id + '_' + 0" :value="0" @change="saveList" v-model="listData" v-on:input="updateList($event)">
                        <input v-else disabled type="radio" class="custom-control-input" :name="name" :id="'search_list_' + searchableList.id + '_' + 0" :value="0" v-model="listData">
                        <label class="custom-control-label" :for="'search_list_' + searchableList.id + '_' + 0"><span v-html="'Unset'"></span></label>
                    </div>
                    <div v-for="item in searchableList.items" :key="item.id" :class="['custom-control-inline', 'custom-control custom-radio']">
                        <input v-if="!readOnly" type="radio" class="custom-control-input" :name="name" :id="'search_list_' + searchableList.id + '_' + item.id" :value="item.id" @change="saveList" v-model="listData" v-on:input="updateList($event)">
                        <input v-else disabled type="radio" class="custom-control-input" :name="name" :id="'search_list_' + searchableList.id + '_' + item.id" :value="item.id" v-model="listData">
                        <label class="custom-control-label" :for="'search_list_' + searchableList.id + '_' + item.id"><span v-html="item.name"></span></label>
                    </div>  
                </template>
                <select v-else class="form-control" :name="name" :value="listData" :key="searchableList.id + '_' + dataItem.id" @change="saveList" v-on:input="updateList($event)">
                    <option v-if="default_select.length == 0 && (!searchableList.hasDefault || forceDefault)" :value="default_select_value">Please select a {{searchableList.name}}</option>
                    <option v-else-if="!searchableList.hasDefault || forceDefault" :value="default_select_value">{{default_select}}</option>
                    <option v-if="!searchableList.hasDefault && showUnset" :value="0">Unset</option>
                    
                    <option v-for="item in searchableList.items" :key="item.id" :value="item.id">{{item.name}}</option>
                </select>
            </div>
        </div>
        <span v-if="!canUpdate || readOnly">{{listDisplay}}</span>
    </div>
</template>

<script>
    import loadcomponents from './loadcomponents'
    export default {
        props: {
            value: {
                type: Number|String
            },
            list: {
                type: Object
            },
            data: {
                type: Object
            },
            dataItem: {
                type: Object
            },
            formGroupClass: {
                type: Array,
            },
            formLabelClass: {
                type: Array,
            },
            formControlClass: {
                type: Array,
            },
        },
        mounted(){
            this.setData(this.data, this.dataItem);
        },
        data() {
            return {
                listData: this.value,
                listDisplay: '',
                hasLoaded: false,
                loading: false,
                showAll: false,
                searchableList: this.list !== undefined && this.list !== null ? this.list : {},
                //the name of the input
                name: 'searchable_list_id',
                //the width
                width: '',
                //the defalt value
                default_select: '',
                //the defalt value
                default_select_value: 0,
                //whether or not to hide the label
                hide_label: true,
                updateRoute: '',
                canUpdate: true,
                refresh_data: false,
                errorOccured: false,
                saving: false,
                autoSave: true,
                forceDefault: false,
                showUnset: false,
                readOnly: false,
                placeHolder: ''
            };
        },
        methods: {
            /**
            * gets the data for the tab
            */
            setData: function (data, item) {
                if(data.searchableList !== undefined){
                    this.searchableList = data.searchableList;
                    this.default_select_value = this.searchableList.defaultValue;
                }
                if(data.autoSave !== undefined){
                    this.autoSave = data.autoSave;
                }
                if(data.forceDefault !== undefined){
                    this.forceDefault = data.forceDefault;
                }
                if(data.placeHolder !== undefined){
                    this.placeHolder = data.placeHolder;
                }
                if(data.showUnset !== undefined){
                    this.showUnset = data.showUnset;
                }
                
                if(item['searchable_list_value_' + this.searchableList.id] !== undefined){
                    this.listData = item['searchable_list_value_' + this.searchableList.id]
                }
                if(item['searchable_list_' + this.searchableList.id] !== undefined){
                    this.listDisplay = item['searchable_list_' + this.searchableList.id]
                }
                if(data.name !== undefined){
                    this.name = data.name;
                } else {
                    this.name = 'searchable_list_id_' + this.searchableList.id + '_' + item.id;
                }
                if(data.width !== undefined){
                    this.width = data.width;
                }
                if(data.default_select !== undefined){
                    this.default_select = data.default_select;
                }
                if(data.default_select_value !== undefined){
                    this.default_select_value = data.default_select_value;
                }
                if(data.hide_label !== undefined){
                    this.hide_label = data.hide_label;
                }
                if(data.readOnly !== undefined){
                    this.readOnly = data.readOnly;
                }
                
                if(item.updateSearchableListRoute !== undefined){
                    this.updateRoute = item.updateSearchableListRoute;
                }
                if(data.canUpdateSearchableList !== undefined){
                    this.canUpdate = data.canUpdateSearchableList;
                }
                if(data.refresh_data !== undefined){
                    this.refresh_data = data.refresh_data;
                }
            },
            /**
             * this job listens to the currently active job and provides an update based on the results
             * 
             * @param data the data it is listening for
             * 
             * @return Array an array of attendance
             */
            saveList: async function() {
                if(this.autoSave && !this.saving){
                    try {
                        this.saving = true;
                        this.errorOccured = false;
                        var params = {}
                        params['searchable_' + this.searchableList.id] = this.listData;
                        const { data } = await this.$http.put(this.updateRoute, params);
                        if(data.messages !== undefined && data.messages.errors !== undefined && data.messages.errors.length > 0){
                            this.errorOccured = true;
                            console.log('An error occurred updating the searchable list');
                            console.log(data.error);
                        } else {
                            
                        }
                    } catch(error) {
                        this.errorOccured = true;
                        console.log('An error occurred updating the searchable list');
                        if(error.response !== undefined){
                            console.log('File: ' + error.response.data.file);
                            console.log('Line: ' + error.response.data.line);
                            console.log('Message: ' + error.response.data.message);
                            console.log('Exception: ' + error.response.data.exception);
                            console.log(error.response.data.trace);
                        } else {
                            console.log(error);
                        }
                    }
                    this.saving = false;
                }
            },
            /**
             * updates the model of the editor to the current value
             * @param String value the value of the editor
             */
            updateList: function (value) {
                var newValue = 0;
                if(value.target !== undefined){
                    newValue = value.target.value;
                } else {
                    newValue = value;
                }
                if(newValue == -3){
                    this.showAll = true;
                    newValue = this.listData;
                } else if(newValue == -2){
                    newValue = this.listData;
                }
                this.listData = newValue;
                this.$emit('input', this.listData);
            },
        },
        watch: {
            /**
             * Handle changes to searchTerm
             */
            value: function() {
                if(this.value != this.listData){
                    this.listData = this.value;
                }
            },
        }
    }
</script>
